<template>
  <div class="main">
      <div v-for="(key,i) in data" :key="i">
            <div class="main__others" v-if="key.length>0">
                <ul>
                    <li
                    :title="item.title+':'+item.value"
                    v-for="(item, index) in key"
                    :key="index"
                    >
                    <span class="title">{{item.title}}: </span>
                    <span
                        class="value"
                        :class="{alarm:alarm.includes(item.value)}"
                    >{{item.value}}</span>
                    </li>
                </ul>
            </div>
      </div>
    <!-- <div
      class="main__others"
      v-if="systemStatus.length>0">
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in systemStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>
    <div
      class="main__list"
      v-if="protectStatus.length>0">
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in protectStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>
    <div
      class="main__list"
      v-if="warnStatus.length>0">
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in warnStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      errorStatus: [],
      protectStatus: [],
      warnStatus: [],
      systemStatus: [],
      alarm: ["报警", "屏蔽", "故障", "告警", "无", "OFF", "未使用",'发生']
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.errorStatus = val.errorStatus || [];
        this.protectStatus = val.protectStatus || [];
        this.systemStatus = val.systemStatus || [];
        this.warnStatus = val.warnStatus || [];
      },
      deep: true,
      immediate: true
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  &__others {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  &__list {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
.alarm {
  color: red !important;
}
</style>